var _style, _path, _rect, _path2, _rect2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKickflip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 341.4 86.2"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:currentColor}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M58.2 66.8 40.9 46.1v20.7h-14V.6h14V37l13.5-16.6H71l-17 21 21.1 25.4z",
  className: "st0"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 46.4,
  x: 77.1,
  y: 20.4,
  className: "st0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M122.4 67.8c-7 0-12.8-2.3-17.4-7s-7-10.4-7-17.2 2.3-12.5 7-17.2c4.6-4.7 10.5-7 17.4-7 6.4 0 11.6 1.8 15.8 5.3s6.9 8.1 8.2 13.8h-14.5c-2.1-4.3-5.2-6.5-9.5-6.5-3 0-5.5 1-7.4 3.1s-2.9 4.9-2.9 8.5 1 6.4 2.9 8.5 4.4 3.1 7.4 3.1c4.3 0 7.4-2.2 9.5-6.5h14.5c-1.3 5.7-4 10.3-8.2 13.8-4.1 3.6-9.4 5.3-15.8 5.3M185.7 66.8l-17.2-20.7v20.7h-14V.6h14V37L182 20.4h16.6l-17.1 21 21.1 25.4zM211.6 66.8V32.6h-9.3V20.4h9.3v-1.8c0-5.7 1.8-10.2 5.3-13.6 3.6-3.4 8-5.1 13.3-5.1 3.3 0 6.1.3 8.4 1v12.3c-1.3-.6-3-.8-5-.8-2.8 0-4.9.6-6.1 1.8s-1.9 3.3-1.9 6h13v12.2h-13v34.2h-14zm34.2 0V.6h14v66.3z",
  className: "st0"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 46.4,
  x: 269.5,
  y: 20.4,
  className: "st0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M307.2 86.2h-14V20.4h14V25c1-1.5 2.6-2.8 4.9-3.9s4.9-1.7 7.7-1.7q9 0 15.3 7.2c6.3 7.2 6.3 10.5 6.3 17.1s-2.1 12.3-6.3 17.1q-6.3 7.2-15.3 7.2c-2.8 0-5.4-.6-7.7-1.7s-3.9-2.5-4.9-3.9zm1.8-34.3c1.9 2.2 4.5 3.2 7.7 3.2s5.7-1.1 7.6-3.2 2.9-4.9 2.9-8.3-1-6.1-2.9-8.3-4.5-3.2-7.6-3.2c-3.2 0-5.7 1.1-7.7 3.2-1.9 2.2-2.9 4.9-2.9 8.3s1 6.1 2.9 8.3",
  className: "st0"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 41.4,
  r: 10,
  className: "st0"
})));
export default SvgKickflip;